import { BaseButtonProps, Button } from '@paytrace/pt-skel/Component'
import React from 'react'

interface ButtonProps extends BaseButtonProps{
}

export function OrangeButton (props: ButtonProps): React.JSX.Element {
  const { className, id, title, disabled } = props
  const classes = className !== undefined ? `orange-button ${className}` : 'orange-button'
  return (
    <div>
      <Button className={classes} id={id} disabled={disabled}>
        <span className={id}>{ title }</span>
      </Button>
    </div>
  )
}
